import React, { useState, useEffect, useRef } from 'react';
import { Modal, Form, Button, ListGroup, Spinner } from 'react-bootstrap';
import messageService from '../../services/messageService';

const MatchMessagesModal = ({ show, onHide, conversationId }) => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const [newMessage, setNewMessage] = useState('');
  const messagesEndRef = useRef(null);

  useEffect(() => {
    if (show && conversationId) {
      fetchMessages();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, conversationId]);

  const fetchMessages = async () => {
    setLoading(true);
    try {
      const data = await messageService.getMessages(conversationId);
      setMessages(Array.isArray(data) ? data : data.data || []);
    } catch (err) {
      console.error('Failed to load messages', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSend = async (e) => {
    e.preventDefault();
    if (!newMessage.trim()) return;
    setSending(true);
    try {
      const sent = await messageService.sendMessage(conversationId, newMessage.trim());
      setMessages(prev => [...prev, sent]);
      setNewMessage('');
    } catch (err) {
      console.error('Failed to send message', err);
    } finally {
      setSending(false);
    }
  };

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Messages</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center my-4">
            <Spinner animation="border" />
          </div>
        ) : (
          <ListGroup className="mb-3">
            {messages.map((msg) => (
              <ListGroup.Item key={msg._id || msg.id}>
                <div className="fw-bold">{msg.senderName || msg.sender}</div>
                <div>{msg.content}</div>
              </ListGroup.Item>
            ))}
            <div ref={messagesEndRef} />
          </ListGroup>
        )}
        <Form onSubmit={handleSend} className="d-flex">
          <Form.Control
            type="text"
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            placeholder="Type a message..."
            disabled={sending}
          />
          <Button type="submit" disabled={!newMessage.trim() || sending} className="ms-2">
            {sending ? 'Sending...' : 'Send'}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default MatchMessagesModal;
